module.exports = __webpack_public_path__ + "media/images/lb/978-8a59f768a176f57b902c648ae28c37a3.svg";